import { useAuthContext } from '@inbox-demo-nx/contexts';
import { useCallback } from 'react';
import SendBird from 'sendbird';

import { isChannelVerified } from './isChannelVerified';

const channelNameMaxMembers = 3;

export function useGetChannelTitle({
  addMemberCount = false,
}: { addMemberCount?: boolean } = {}) {
  const { currentUser } = useAuthContext();
  const currentUserId = currentUser?.userId;
  return useCallback(
    (channel: SendBird.GroupChannel) => {
      if (isChannelVerified(channel)) {
        return channel.name;
      }

      if (channel.name && channel.name !== 'Group Channel') {
        return channel.members.length < 3
          ? channel.name
          : `${channel.name}${
              addMemberCount ? ` (${channel.members.length})` : ''
            }`;
      }

      const nicknames = channel.members
        .filter((m) => m.userId !== currentUserId)
        .map((m) => m.nickname);

      if (nicknames.length > channelNameMaxMembers) {
        return `${nicknames
          .slice(0, channelNameMaxMembers + 1)
          .join(', ')} and ${nicknames.length - channelNameMaxMembers} others`;
      }
      return `${nicknames.join(', ')}`;
    },
    [addMemberCount, currentUserId]
  );
}
